import { render, staticRenderFns } from "./LoanHistory.vue?vue&type=template&id=39257c5f"
import script from "./LoanHistory.vue?vue&type=script&lang=js"
export * from "./LoanHistory.vue?vue&type=script&lang=js"
import style0 from "./LoanHistory.vue?vue&type=style&index=0&id=39257c5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports